import { createVanIconComponent } from "./van"

const Setting = createVanIconComponent("setting")
export default Setting
